var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type,attrs:{"id":"box"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('a-button',{staticClass:"button",style:({
                    height:_vm.height,
                    lineHeight:_vm.height,
                    borderRadius:_vm.borderRadius,
                    padding:_vm.padding,
                    fontSize:_vm.fontSize,
            }),attrs:{"disabled":_vm.disabled,"type":"primary","loading":_vm.loading}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }